<script>
  import { astroData } from "../stores/astroData.js";
  import Details from "./Details.svelte";
  import Navigation from "./Navigation.svelte";
  import { writable } from 'svelte/store';
  import { pGlyph, sGlyph, aGlyph } from '../stores/glyph.js';
  import { padding, makeReadable, decodeHtml } from '../utils/utils.js';
 
  const aspects = writable([]);
  let showDominant = false;

  $: planets = $astroData.planets;
  $: houses = $astroData.houses;
  $: hasData = planets.length > 0 || houses.length > 0;

  // if hasData is true, run the calculateAspects function
  $: if (hasData) {
    calculateAspects(planets, houses);
  }

  function checkAspect(distance, aspectDegrees, orbRange, planet1, planet2) {
    if (
      distance > aspectDegrees - orbRange &&
      distance < aspectDegrees + orbRange
    ) {
      const orb = Math.abs(distance - aspectDegrees);
      aspects.update(aspectsArr => {
        aspectsArr.push({
          planet1,
          planet2,
          aspectDegrees,
          orb
        });
        return aspectsArr;
      });
    }
  }

  function displayOrb(orb) {
    const degree = Math.floor(orb);
    const remainder = (orb - degree) * 60;
    const minute = Math.floor(remainder);
    const second = Math.floor((remainder - minute) * 60);
    return `${degree}°${padding(minute)}'${padding(second)}"`;
  }
/*
  function padNumber(number) {
    return number.toString().padStart(2, "0");
  }
*/
  function calculateAspects(planets, houses) {
    planets[11] = {
      pos: houses[0].long,
      naam: "Ascendant",
      speed: 0,
    };
    planets[12] = {
      pos: houses[9].long,
      naam: "Midhemel",
      speed: 0,
    };

    // add pGlyp to planets array as a new property glyph
    planets.forEach((planet, index) => {
      planet.glyph = pGlyph[index];
    });

    for (let p1 = 0; p1 <= 12; p1++) {
      if (p1 > 9) continue;

      for (let p2 = p1 + 1; p2 <= 12; p2++) {
        let distance = Math.abs(planets[p1].pos - planets[p2].pos);
        if (distance > 180) distance = 360 - distance;

        // Define aspects as an array of objects with aspectDegrees and orbRange properties
        const aspectsToCheck = [
          { aspectDegrees: 0, orbRange: 6 }, // conjunctie
          { aspectDegrees: 180, orbRange: 6 }, // oppositie
          { aspectDegrees: 90, orbRange: 6 }, // vierkant
          { aspectDegrees: 45, orbRange: 2 }, // halfvierkant
          { aspectDegrees: 135, orbRange: 2 }, // anderhalfvierkant
          { aspectDegrees: 120, orbRange: 5 }, // driehoek
          { aspectDegrees: 60, orbRange: 4 }, // sextiel
          { aspectDegrees: 150, orbRange:2 }, // inconjunct
        ];

        for (const aspect of aspectsToCheck) {
          checkAspect(
            distance,
            aspect.aspectDegrees,
            aspect.orbRange,
           p1,
            p2
          );
        }
      }
    }
  }

function checkDom(planet2, aspectDegrees, orb){
    if (planet2 === 11 || planet2 === 12) {
      if ([0, 45, 90, 135, 180].includes(aspectDegrees) && orb < 2) {
        return true;
      }
    }
    return false;
}

function toggleDominant() {
  showDominant = !showDominant;
}

function getGlyph(degValue) {
  degValue=parseInt(degValue);
  const glyphObj = aGlyph.find(item => item.deg === degValue);
  return glyphObj ? glyphObj.glyph : '';
}
</script>

<div class="container">
  <Navigation />
  <Details />
  <h3>Aspecten</h3>
      <table class="aspects-table">
        <thead>
          <tr>
            <th> </th>
            <th> </th>
            <th> </th>
            <th>Orb</th>
            <th>Planeet 1</th>
            <th>Planeet 2</th>
          </tr>
        </thead>
        {#each $aspects as aspect}
          <tr class="highlight" style="{checkDom(aspect.planet2, aspect.aspectDegrees, aspect.orb) && showDominant ? 'background-color: #ffcccb' : ''}">
            <td class="astro-font">{decodeHtml(pGlyph[aspect.planet1])}</td>
            <td class="astro-font">{@html getGlyph(aspect.aspectDegrees)}</td>  
            <td class="astro-font">{decodeHtml(pGlyph[aspect.planet2])}</td>
            <td>{displayOrb(aspect.orb)}</td>
            <td>{@html makeReadable(planets[aspect.planet1].pos, sGlyph)}</td>
            <td>{@html makeReadable(planets[aspect.planet2].pos, sGlyph)}</td>
          </tr>
        {/each}
      </table>
      <div class="toggle not-print">
        <a href="#dominant" role="button" tabindex="0" on:click|preventDefault={toggleDominant}>
        {#if showDominant}
          Verberg Dominante aspecten
            {:else}
              Toon Dominante aspecten
            {/if}
          </a>
        </div>
    </div>

<style>
  table.aspects-table {
    border-collapse: collapse;
    margin-bottom: 0.5rem;
    width: 100%;
  }
  table.aspects-table td,
  table.aspects-table th {
    text-align: left;
  }
  table.aspects-table th {
    background-color: #f2f2f2;
    font-weight: bold;
  }
  table.aspects-table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  table.aspects-table tr:hover {
    background-color: #e6e6e6;
  }
  .highlight:hover {
    background-color: #ffcccc; 
  }

  .toggle {
  text-align: right;
  }
  .toggle a {
    text-decoration: none;
    font-size: 0.8em; 
    color: darkslateblue; 
  }
  .toggle a:hover {
    color: #ff6347;  
  }

  @media print {
      .not-print {
        display: none;
      }
  }
</style>
